import React from 'react';
import {Card, Divider} from 'antd-mobile';
import {useNavigate} from 'react-router-dom';
import {TmsWaypointWithAddressType} from '../../graphql/queries/getTmsPublishedTaskByDriverAccountId';
import {buildAddress1AndAddress2} from '../../../../utils/addressUtils';
import {formatTimestampByLanguage} from '../../../../utils/dateTimeUtils';
import {useTranslation} from "react-i18next";
import {TmsPath, TmsPathPre} from "../../../../enums/TmsNavigatePathEnum";
import {t} from "../../../../i18n";

interface WayPointCardProps {
    data: TmsWaypointWithAddressType;
}

const WayPointCard: React.FC<WayPointCardProps> = ({data}) => {
    const navigate = useNavigate();
    const status = data.status === 'DONE' || data.isFinished;
    const startPoint = data.waypointType === 1;
    const endPoint = data.waypointType === 3;
    const { i18n } = useTranslation();

    const handleCardClick = () => {
        const mainContainer = document.getElementById('tms-main-container') as HTMLElement;
        if (mainContainer) {
            sessionStorage.setItem('tmsPageScrollTop', mainContainer.scrollTop.toString());
        }
        // 导航到详情页
        navigate(TmsPathPre.TMS_TRANSPORTING_DETAIL_PRE + `${data.taskWayPointId}/${data.waypointType}`);
    };

    return (
        <Card
            className="my-2 rounded-lg"
            style={{
                backgroundColor: status ? '#e5e7eb' : '#ffffff'
            }}
            onClick={handleCardClick}
        >
            <div className="flex items-baseline">
                <div className="text-sm font-medium truncate flex-1 min-w-0 mr-3">
                    {data.wayPointName || 'Waypoint'}{' '}
                    {data.warehouseSiteType == 1 && (
                        <span className="bg-red-500 text-white text-xs font-medium px-0 py-0 rounded whitespace-nowrap">
                             HUB
                        </span>
                    )}
                    {data.warehouseSiteType == 2 && (
                        <span className="bg-green-500 text-white text-xs font-medium px-0 py-0 rounded whitespace-nowrap">
                             WHS
                        </span>
                    )}
                </div>

                {/* 标签容器 */}
                <div className="flex-shrink-0">
                    {status && (
                        <span className="text-xs font-medium text-gray-500 whitespace-nowrap">
                            {t('pages.tms.transporting.arrivedFinished')}
                        </span>
                    )}
                    {data.isAbnormal && !status && (
                        <span className="bg-red-500 text-white text-xs font-medium px-2 py-1 rounded whitespace-nowrap">
                            Abnormal
                        </span>
                    )}
                </div>
            </div>
            <Divider/>
            <div className="flex gap-6">
                <div className="flex flex-col w-14 items-center justify-center gap-0.5 flex-shrink-0">
                    <div className="text-2xl font-bold">
                        {startPoint ? t('pages.tms.start') : endPoint ? t('pages.tms.end') : data.sequence}
                    </div>
                </div>
                <div className="flex flex-col gap-1 flex-1 min-w-0">
                    <h3 className="text-sm font-semibold break-words">{buildAddress1AndAddress2({
                        addressLine1: data.addressLine1 ?? undefined,
                        addressLine2: data.addressLine2 ?? undefined
                    })}</h3>
                    {data.quantity > 0 && (
                        <p className="text-xs">Quantity：{data.quantity}</p>
                    )}
                    {data.planArrivalTime && (
                        <p className="text-xs">
                            <span>{t('pages.tms.transporting.planArrivalTime')}：</span>
                            <span className="text-[#6366f1]">{formatTimestampByLanguage(data.planArrivalTime, i18n.language)}{data.planArrivalTimezone ? ` (${data.planArrivalTimezone})` : ''}</span>
                        </p>
                    )}
                    {data.planDepartureTime && (
                        <p className="text-xs">
                            <span>{t('pages.tms.transporting.planDepartureTime')}：</span>
                            <span className="text-[#6366f1]">{formatTimestampByLanguage(data.planDepartureTime, i18n.language)}{data.planDepartureTimezone ? ` (${data.planDepartureTimezone})` : ''}</span>
                        </p>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default WayPointCard;

